import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';
import { USAGE_TYPES } from '../../../Utils/Enums';
import { getAddUsageButtonLabel, getAddUsageButtonTestKey } from '../../../Utils/Getter';

import styles from './UsageViewItem.Styles';

const getPlaceholders = usageData => {
  const { usageType, isUnlimited, remainingAmount, remainingUnits, totalAmount, totalUnits } =
    usageData;

  const placeholders = [];
  if (!isUnlimited) {
    switch (usageType) {
      case USAGE_TYPES.DATA:
        placeholders.push(remainingAmount + remainingUnits);
        placeholders.push(totalAmount + totalUnits);
        break;
      case USAGE_TYPES.CALLS:
        placeholders.push(remainingAmount.toString());
        placeholders.push(totalAmount + ' ' + totalUnits);
        break;
      case USAGE_TYPES.SMS:
        placeholders.push(remainingAmount.toString());
        placeholders.push(totalAmount.toString());
        break;
    }
  }
  return placeholders;
};

function UsageViewItem({
  usageType,
  isUnlimited,
  remainingAmount,
  remainingUnits,
  totalAmount,
  totalUnits,
  shouldShowAddUsageButton,
  containerStyle,
  images,
  onAddUsagePress,
  usedAmount,
  ...props
}) {
  const theme = useTheme();

  const usageItemPlaceHolders = getPlaceholders({
    usageType,
    isUnlimited,
    remainingAmount,
    remainingUnits,
    totalAmount,
    totalUnits,

  });

  return (
    <View style={containerStyle}>
      <View style={styles.usageFirstRow}>
        <VFText
          i18nKey={`${usageType}:`}
          style={styles.usageLabelTextStyle(theme)}
          testKey={SohoFrameworkTestKeys.PlanProductTitle}
        />
        <VFText
          i18nKey={
            !isUnlimited ? usageItemPlaceHolders[1] : 'soho_plans_plan_unlimited_consumption'
          }
          style={styles.usedAmountTextStyle(theme)}
          testKey={SohoFrameworkTestKeys.planProductUsageValue}
        />
      </View>
      {!isUnlimited ? (
        <View>
          <VFText
            i18nKey="soho_plans_plan_left"
            placeHolders={usageItemPlaceHolders}
            style={styles.totalAmountTextStyle(theme)}
            testKey={SohoFrameworkTestKeys.planUsageNote}
          />
          {shouldShowAddUsageButton ? (
            <VFButton
              title={getAddUsageButtonLabel(usageType)}
              type="secondary"
              style={styles.addButtonStyle}
              textStyle={styles.addButtonTextStyle(theme)}
              onPress={onAddUsagePress}
              testKey={getAddUsageButtonTestKey(usageType)}
            />
          ) : null}
        </View>
      ) : null}
    </View>
  );
}

UsageViewItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  usageType: PropTypes.string,
  icon: PropTypes.string,
  isUnlimited: PropTypes.bool,
  totalAmount: PropTypes.number,
  totalUnits: PropTypes.string,
  remainingAmount: PropTypes.number,
  remainingUnits: PropTypes.string,
  valuePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shouldShowAddUsageButton: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  images: PropTypes.object,
  onAddUsagePress: PropTypes.func,
};

export default UsageViewItem;
